/* CRF hero video.
   The markup carries autoplay, because that is the well-trodden path through
   Shopify's video_tag. Reduced motion is handled twice over: CSS hides the
   video element, and this pauses it so nothing decodes in the background. */
(function () {
  document.querySelectorAll('.crf-hero').forEach(function (hero) {
    var video = hero.querySelector('.crf-hero__video video, video.crf-hero__video');
    var toggle = hero.querySelector('[data-crf-video-toggle]');
    if (!video || !toggle) return;

    var calm = window.matchMedia('(prefers-reduced-motion: reduce)');

    function setState(playing) {
      toggle.dataset.state = playing ? 'playing' : 'paused';
      toggle.setAttribute('aria-label', (playing ? 'Pause' : 'Play') + ' background video');
    }
    function start() {
      var p = video.play();
      if (p && p.catch) p.catch(function () { setState(false); });
    }

    // Seed the control from the video rather than from the default. Autoplay
    // starts before this script attaches, and calling play() on an already
    // playing video fires no 'play' event -- so without this the button sat
    // showing "play" over footage that was already running.
    setState(!video.paused);
    if (calm.matches) video.pause(); else start();
    video.addEventListener('play', function () { setState(true); });
    video.addEventListener('pause', function () { setState(false); });
    toggle.addEventListener('click', function () {
      if (video.paused) start(); else video.pause();
    });
    calm.addEventListener('change', function (e) { if (e.matches) video.pause(); });
  });
}());
